"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cart_1 = require("../modules/cart");
var slider_1 = require("../modules/slider");
var get_element_1 = require("../utils/get_element");
var IDS = {
    CART_FORM: 'js-cart-form',
};
var initCartEvent = function () {
    var cartForm = (0, get_element_1.getElementById)(IDS.CART_FORM);
    (0, cart_1.setupCart)(cartForm, { type: cart_1.CART_TYPE.DETAIL });
};
initCartEvent();
(0, slider_1.setupSlider)();
